import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { BlockList } from '@wordpress/block-editor';
import { useContext, createPortal } from '@wordpress/element';
export default function GapStyles(_ref) {
  let {
    blockGap,
    clientId
  } = _ref;
  const styleElement = useContext(BlockList.__unstableElementContext); // --gallery-block--gutter-size is deprecated. --wp--style--gallery-gap-default should be used by themes that want to set a default
  // gap on the gallery.

  const gapValue = blockGap ? blockGap : `var( --wp--style--gallery-gap-default, var( --gallery-block--gutter-size, var( --wp--style--block-gap, 0.5em ) ) )`;
  const gap = `#block-${clientId} { 
		--wp--style--unstable-gallery-gap: ${gapValue};
		gap: ${gapValue} 
	}`;

  const GapStyle = () => {
    return createElement("style", null, gap);
  };

  return gap && styleElement ? createPortal(createElement(GapStyle, null), styleElement) : null;
}
//# sourceMappingURL=gap-styles.js.map